import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export var WidgetSmallMultiplesPieChart: Widget = {
    type: 'smallMultiplesPieChart',
    id: 'small-multiples-pie-chart',
    name: 'Small Multiples',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 9,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicName },
                    INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_ACCOUNT_ID' },
                    PAID: { dimensionName: 'accountIds' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'STORY_CATEGORY' },
                    SPR_TASK: { dimensionName: 'ASSIGNEE_ID' },
                    SAM: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    AUDIENCE_ACTIVITY: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    OUTBOUND_MESSAGE: {
                        source: ListeningDimensions.account,
                    },
                    CONSUMPTION: {
                        source: ListeningDimensions.activityType,
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
            includeTotal: true,
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Small Multiples Pie Chart',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        arrangement: 'grid',
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
};
